import React from "react";
import "./App.css";
import VPNSelector from "./VPNSelector"; // Import VPNSelector component

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src="/company-logo.png" alt="Company Logo" className="w-full h-auto" /> {/* Updated for full width and responsiveness */}
        <h1>Welcome to Kalypso VPN Selector</h1>
        <VPNSelector /> {/* Display the VPN selector */}
      </header>
    </div>
  );
}

export default App;
